<div class="card p-2 h-100">
    <h5 class="card-title">Appointments</h5>
    <p>{{appointmentCount}} appointments in the last {{days}} days</p>
    <ngb-alert *ngIf="errorMessage" type="danger" [dismissible]="true" (closed)="clearError()">{{errorMessage}}</ngb-alert>
    <a type="button" class="btn btn-primary mt-auto" routerLink="/sup/history">View appointments</a>
</div>
